import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import {Typography} from "@mui/material";

const useStyles = makeStyles({
  root: {
    padding: '.3rem 1.5rem',
    textAlign: 'center',
    display: 'inline-block',
    fontSize: 16,
    textTransform: 'uppercase',
    zIndex: 2,
    position: 'absolute',
    top: 0,
    right: 0,
    maxWidth: "calc(100% - 4rem)",
    lineHeight: 1.25,
    fontWeight: 700,
    minWidth: 160,
    fontFamily: "Lato",
  },
  statusBanner: {
    width: "100%",
    padding: ".4rem 0",
    fontSize: 20,
    position: 'relative',
    display: 'block',
    maxWidth: '100%',
    color: props => props.statusColor ? props.statusColor : 'white',
  },
  featured: {
    border: "6px solid rgb(23, 115, 164)",
  }
});

export default function ListingStatus(props) {
  const { label, statusBanner, strongLabel, message, statusColor, statusBgColor, custom } = props;
  const classes = useStyles(props);
  let msg = (typeof message !== 'string') ? 'LISTING STATUS: ' : message;

  return (
    <Box className={clsx(classes.root, {[classes.featured]: custom}, {[classes.statusBanner]: statusBanner === 1})}
         bgcolor={statusBgColor} color={statusColor} >
      <Typography variant='body2' component='p' style={{ color: statusColor, fontWeight: custom ? 900: 400 }}>
        {statusBanner === 1 ? msg : ''} {label} {strongLabel}
      </Typography>
    </Box>
  );
};
